module.exports = __webpack_public_path__ + "img/pets.596e0ae3.svg";